import { Area } from "./GeometricLayout";

/**
 * @param computedStyle the computed style of the editor to get the content area
 * @returns an area representing the text content. It is meant to lay out a mirror for a text area, so that it can accurately simulate
 * text flow layouts.
 */
export default function getContentArea(
  size: {
    offsetWidth: number;
    offsetHeight: number;
    clientWidth: number;
    clientHeight: number;
  },
  computedStyle: {
    width: string;
    height: string;
    paddingRight: string;
    paddingLeft: string;
    paddingTop: string;
    paddingBottom: string;
    boxSizing: string;
  }
): Area {
  const isBorderBox = computedStyle.boxSizing === "border-box";

  const scrollBarWidth = size.offsetWidth - size.clientWidth;
  const scrollBarHeight = size.offsetHeight - size.clientHeight;

  const cssWidth = Number.parseFloat(computedStyle.width);
  const xPadding =
    Number.parseFloat(computedStyle.paddingRight) +
    Number.parseFloat(computedStyle.paddingLeft);
  const caWidth = isBorderBox ? cssWidth - xPadding - scrollBarWidth : cssWidth;

  const cssHeight = Number.parseFloat(computedStyle.height);
  const yPadding =
    Number.parseFloat(computedStyle.paddingTop) +
    Number.parseFloat(computedStyle.paddingBottom);
  const caHeight = isBorderBox
    ? cssHeight - yPadding - scrollBarHeight
    : cssHeight;

  return {
    height: caHeight,
    width: caWidth,
  };
}
